import * as Constants from '../../../constants';

export default {
	getClaimDetails(claimID) {
		let claimsHeaders = new Headers({
			'AuthenticatedUser': window.LMC.authenticatedUser
		});
		return fetch(Constants.ENVIRONMENT_API + `claims/GetClaimDetail?claimID=` + claimID, {
			headers: claimsHeaders
		})
			.then(response => {
				if (response.ok) {
					return Promise.resolve(response);
				}
				else {
					return Promise.reject(new Error(error));
				}
			})
			.then(response => response.json())
			.then(data => {
				// stuff on success
				return data;
				
			})
			.catch(error => {
				console.log(error);
			});
	}
};